import { render } from "./SidebarContent.vue?vue&type=template&id=2e804ed7"
import script from "./SidebarContent.vue?vue&type=script&lang=js"
export * from "./SidebarContent.vue?vue&type=script&lang=js"

import "./SidebarContent.vue?vue&type=style&index=0&id=2e804ed7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__